import React, { FC } from 'react';

import { observer } from 'mobx-react-lite';
import { Box, Typography, styled } from '@mui/material';
import { AnsprechPersonDetails } from '@codefluegel/wowis-rest-typescript-client';

import CardContainer from './CardContainer';
import ThemedButton from '../button/ThemedButton';
import useMedia from '../../hooks/useMedia';

const StyledText = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main,
  margin: 5,
  marginTop: 0,
  marginBottom: 0,
  paddingTop: 0,
  paddingBottom: 0,
}));

interface Props {
  contact: AnsprechPersonDetails;
  height?: number;
  width?: number;
  iconCenter?: boolean;
  iconColor?: string;
  iconOn?: boolean;
  bgcolor?: string;
  headerBGColor?: string;
}

const Card: FC<Props> = observer(props => {
  const {
    contact,
    height,
    width,
    iconOn,
    iconCenter,
    iconColor,
    bgcolor,
    headerBGColor,
  } = props;

  const currentUserType = `${contact.user_art}`;
  const isMobile = useMedia('md');

  return (
    <CardContainer
      customStyle={{ m: 1, mb: 0, margin: 0 }}
      iconOn={iconOn}
      iconCenter={iconCenter}
      iconColor={iconColor}
      bgcolor={bgcolor}
      headerBGColor={headerBGColor}
      iconName={currentUserType}
    >
      <Box
        p={5}
        pt={0}
        width={isMobile ? '330px' : width}
        height={height}
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'space-between',
          top: '-30px',
        }}
      >
        <Box
          width="210px"
          height={1}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'center',
            justifyContent: 'center',
            mb: 0,
          }}
        >
          <StyledText
            textAlign={iconCenter ? 'center' : 'left'}
            sx={{
              fontWeight: 'fontWeightBold',
              overflowWrap: 'break-word',
              paddingBottom: 1,
              fontSize: isMobile ? 13 : 12,
            }}
          >
            {`${contact.user_art}` || ''}
          </StyledText>
          <StyledText variant="body1" p={0} textAlign="center">
            {`${contact.firstname || ''} ${contact.surname || ''}`}
          </StyledText>
          {contact.kont?.dw && (
            <StyledText
              textAlign={iconCenter ? 'center' : 'left'}
              variant="body1"
              p={1}
              onClick={() => window.open(`tel:${contact.kont?.dw}`)}
              sx={{
                cursor: 'pointer',
              }}
            >
              {`T: ${contact.kont?.dw}`}
            </StyledText>
          )}
        </Box>
        <Box minWidth={150} sx={{ mt: 2 }}>
          <ThemedButton
            label="Mail senden"
            onClick={() => window.open(`mailto:${contact.kont?.email}`)}
          />
        </Box>
      </Box>
    </CardContainer>
  );
});

export default Card;
